var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-list-wrap"},[_c('ul',{staticClass:"custom-scroller"},_vm._l((_vm.the_rule_data.activity_rules),function(rule,id){return _c('p',[_c('span',{staticClass:"num"},[_vm._v(_vm._s(id+1)+". ")]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(rule.content))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-149832b6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ActRules/list.vue
// module id = 180
// module chunks = 0